import { ItemViewType } from "constants/types";

export const getDefaultView: () => ItemViewType = () => ItemViewType.Panel;

export const getNodeKey = (node: { entry?: { id?: string }; item?: { _id?: string } }): string | undefined =>
    node?.entry?.id ?? node?.item?._id;
